import { Link } from "react-router-dom";
import SEO from "../components/SEO";
import CTAStrip from "../components/CTAStrip";
import { COMPANY } from "../data/site";

const ZONES_CATEGORIES = [
    {
        title: "Pays de Gex",
        cities: ["Saint-Jean-de-Gonville", "Thoiry", "Gex", "Ferney-Voltaire", "Divonne-les-Bains", "Prévessin-Moëns", "Ornex", "Cessy", "Sergy", "Crozet", "Saint-Genis-Pouilly"],
    },
    {
        title: "Haute-Savoie",
        cities: ["Annemasse", "Saint-Julien-en-Genevois", "Reignier-Ésery", "Cranves-Sales", "Vétraz-Monthoux", "Gaillard"],
    },
    {
        title: "Genève · Vaud · La Côte",
        cities: ["Genève", "Versoix", "Coppet", "Founex", "Mies", "Tannay", "Nyon", "Gland", "Begnins", "Rolle", "Aubonne", "Morges"],
    },
];

export default function Zones() {
    return (
        <>
            <SEO
                title="Zones d'intervention de Portail du Léman"
                description="Pose de portail, clôture, brise-vue et motorisation autour de Genève, Pays de Gex, Haute-Savoie et bassin lémanique."
                keywords={["zones d'intervention", "portail Pays de Gex", "portail Genève", "portail Haute-Savoie"]}
            />
            <section className="max-w-[1400px] mx-auto px-6 lg:px-10 pt-20 pb-12">
                <div className="divider-tag mb-6">Où nous intervenons</div>
                <h1 className="font-display text-4xl md:text-6xl text-white leading-[1.05] tracking-tight max-w-4xl">
                    Pose de portail autour de Genève,<br />
                    <span className="italic text-white/80">Pays de Gex et Haute-Savoie.</span>
                </h1>
                <p className="mt-6 text-white/65 max-w-3xl">
                    Basés à Saint-Jean-de-Gonville, nous intervenons quotidiennement dans tout le Pays de Gex, sur Genève et la Haute-Savoie limitrophe. Nous nous déplaçons également dans le canton de Vaud, sur toute La Côte — de Coppet à Morges en passant par Nyon, Gland et Rolle.
                </p>
            </section>

            <section className="max-w-[1400px] mx-auto px-6 lg:px-10 pb-20 md:pb-28 grid md:grid-cols-3 gap-px bg-white/[0.07] border border-white/[0.07]">
                {ZONES_CATEGORIES.map((z) => (
                    <div key={z.title} className="bg-[#0B141C] p-8">
                        <div className="divider-tag mb-5">{z.title}</div>
                        <ul className="space-y-2.5">
                            {z.cities.map((c) => (
                                <li key={c} className="text-white/75 text-sm flex items-center gap-2">
                                    <span className="w-1 h-1 bg-brand-accent rounded-full" /> {c}
                                </li>
                            ))}
                        </ul>
                    </div>
                ))}
            </section>

            <section className="max-w-[1400px] mx-auto px-6 lg:px-10 pb-20">
                <div className="divider-tag mb-5">Pages dédiées</div>
                <h2 className="font-display text-3xl md:text-4xl text-white mb-8">Pages locales détaillées</h2>
                <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3">
                    {[
                        ["/portail-geneve", "Portail Genève"],
                        ["/portail-pays-de-gex", "Portail Pays de Gex"],
                        ["/portail-gex", "Portail Gex"],
                        ["/portail-ferney-voltaire", "Portail Ferney-Voltaire"],
                        ["/portail-divonne-les-bains", "Portail Divonne"],
                        ["/portail-saint-genis-pouilly", "Portail Saint-Genis"],
                        ["/portail-annemasse", "Portail Annemasse"],
                        ["/portail-haute-savoie", "Portail Haute-Savoie"],
                        ["/brise-vue-geneve", "Brise-vue Genève"],
                        ["/cloture-pays-de-gex", "Clôture Pays de Gex"],
                    ].map(([to, label]) => (
                        <Link key={to} to={to} className="border border-white/[0.08] p-4 text-sm text-white/75 hover:border-brand-accent/60 hover:text-brand-accent transition">
                            {label}
                        </Link>
                    ))}
                </div>
                <p className="mt-12 text-xs text-white/45 max-w-3xl">
                    Nous intervenons également dans d'autres communes proches : {COMPANY.areas.join(", ")}.
                </p>
            </section>

            <CTAStrip />
        </>
    );
}
